<template>
  <div class="addInformation">
    <el-button type="primary" @click="dialogAddEditNoticeVisible = true">添加平台公告</el-button>
    <el-divider></el-divider>
    <el-table :data="listTable" border :header-cell-style="{ textAlign: 'center' }" v-loading="loadingTable">
      <el-table-column prop="id" label="序号" width="100" align="center" sortable></el-table-column>
      <el-table-column prop="title" label="标题" align="center"></el-table-column>
      <el-table-column prop="updateTime" label="更新时间" width="300" align="center" sortable></el-table-column>
      <el-table-column prop="releaseTime" label="发布时间" width="300" align="center" sortable></el-table-column>
      <el-table-column prop="releaseTime" label="状态" width="300" align="center">
        <template slot-scope="scope">
          <div v-if="scope.row.state === 0">未发布</div>
          <div v-else-if="scope.row.state === 1">已撤回</div>
          <div v-else-if="scope.row.state === 2">已发布</div>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="250" align="center">
        <template slot-scope="scope">
          <template v-if="scope.row.state === 2">
            <el-button type="primary" @click="seeNotice(scope.row)">查看</el-button>
            <el-button type="danger" @click="recallNotice(scope.row)">撤回</el-button>
          </template>
          <template v-else>
            <el-button type="warning" @click="editNotice(scope.row)">编辑</el-button>
            <el-button type="primary" @click="releaseNotice(scope.row)">发布</el-button>
            <el-button type="danger" @click="delNotice(scope.row)">删除</el-button>
          </template>
        </template>
      </el-table-column>
    </el-table>
    <div class="pagination-container">
      <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="page"
          :page-sizes="[20, 50, 100, 200, 300]"
          :page-size="size"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
      ></el-pagination>
    </div>
    <!-- 添加平台公告弹框 -->
    <el-dialog :title="dialogTitle" :visible.sync="dialogAddEditNoticeVisible" width="60%" @close="dialogClose"
               top="4vh">
      <el-row type="flex" justify="space-between" align="middle" class="add-notice-row">
        <h3 class="title">标题：</h3>
        <el-input v-model="formAddNotice.title"></el-input>
      </el-row>
      <tinymce ref="tinymce" v-model="formAddNotice.content" :height="500" class="add-notice-row" />
      <el-row type="flex">
        <el-upload class="upload-container" ref="uploadMultiple" :action="action" :on-remove="handleRemove"
                   :on-success="handleSuccess" :headers="customHeaders" style="margin-left: 10px;"
                   name="multipartFile" multiple :show-file-list="false">
          <el-button size="small" type="primary">上传附件</el-button>
        </el-upload>
      </el-row>
      <div style="margin: 10px 0;" v-for="(item, index) in formAddNotice.accessoryList" :key="index">
        {{ `${ index + 1 }. ${ item.accessoryName }` }}
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogAddEditNoticeVisible = false">取 消</el-button>
        <el-button type="primary" @click="updateNoticeSave" :loading="loadingStatus === 'updateNoticeSave'">保 存
        </el-button>
      </div>
    </el-dialog>

    <el-dialog title="公告详情" :visible.sync="dialogSeeNoticeVisible" width="60%" @close="dialogClose" top="4vh">
      <el-row type="flex" justify="space-between" align="middle" class="add-notice-row">
        <h3 class="title">标题：</h3>
        <el-input v-model="seeForm.title" readonly></el-input>
      </el-row>
      <div class="notice-content" v-html="seeForm.content"></div>
      <div style="margin: 20px 0 5px;">附件：</div>
      <div v-for="(item, index) in seeForm.accessoryList" :key="index">
        <el-link :href="item.accessoryUrl" target="_blank">{{ `${ index + 1 }. ${ item.accessoryName }` }}</el-link>
      </div>
      <!-- <div @click="uploadFile" style="cursor: pointer;"></div> -->
    </el-dialog>
  </div>
</template>

<script>
import Tinymce from "@/components/Tinymce";
import { ajaxPost, Baseurl } from "@/api/api/api";

export default {
  name: "addInformation",
  components: {
    Tinymce,
  },
  data() {
    return {
      UserInfo: {},
      page: 1,
      size: 20,
      total: 0,
      listTable: [],
      dialogType: "add",
      dialogAddEditNoticeVisible: false,
      formAddNotice: {
        title: "",
        content: "",
        accessoryList: [],
      },
      action: Baseurl + "imageController/uploadFile",
      customHeaders: { token: localStorage.getItem("token") },
      loadingStatus: "",
      fileList: [],

      dialogSeeNoticeVisible: false,
      seeForm: {},
      loadingTable: false,
    };
  },
  created() {
    this.UserInfo = JSON.parse(localStorage.getItem("role"));
    this.getListTable();
  },
  computed: {
    dialogTitle() {
      return this.dialogType === "add" ? "新增公告" : "编辑公告";
    },
  },
  methods: {
    handleSizeChange(val) {
      this.size = val;
      this.getListTable();
    },
    handleCurrentChange(val) {
      this.page = val;
      this.getListTable();
    },
    handleRemove(file) {
      // console.log(fileList);
      const { name, id } = file;
      const arr1 = this.formAddNotice.accessoryList;
      const arr2 = this.fileList;
      for (let i = 0, len = arr1.length; i < len; i++) {
        if (arr1[i].accessoryName === name) {
          arr1.splice(i, 1);
          break;
        }
      }
      for (let i = 0, len = arr2.length; i < len; i++) {
        if (arr2[i].name === name) {
          arr2.splice(i, 1);
          break;
        }
      }
      if (this.dialogType !== "edit") return;
      this.removeFile(id);
    },
    handleSuccess(response, file, fileList) {
      const { code, data } = response;
      if (code === 200) {
        const { fileName, accessoryUrl, uploadTime } = data
        const obj = {
          accessoryName: fileName,
          accessoryUrl: accessoryUrl,
          uploadTime: uploadTime,
        };
        this.formAddNotice.accessoryList.push(obj);
      } else {
        this.$message.error(data)
      }
    },
    updateNoticeSave() {
      let API = "";
      if (this.dialogType === "add") {
        API = Baseurl + "announcementController/insertAnnouncementInfo";
      } else if (this.dialogType === "edit") {
        API = Baseurl + "announcementController/updateAnnouncementInfo";
      }
      // 给ul li标签添加class
      const rgx = /(?<=(<li))|(?<=(<ul))|(?<=(<ol))/gm
      const str = ' class="no-reset"'
      this.formAddNotice.content = this.formAddNotice.content.replace(rgx, str)
      const paramsData = {
        rid: this.UserInfo.rid,
        ...this.formAddNotice,
      };
      this.loadingStatus = "updateNoticeSave";
      ajaxPost(API, paramsData).then(res => {
        const { data: { code } } = res;
        this.loadingStatus = "";
        if (code === 200) {
          this.dialogAddEditNoticeVisible = false;
          this.$message.success("操作成功");
          this.getListTable();
        }
      });
    },
    dialogClose() {
      this.dialogType = "add";
      this.formAddNotice = {
        title: "",
        content: "",
        accessoryList: [],
      };
      this.fileList = [];
      this.$refs.tinymce.setContent("");
    },
    getListTable() {
      const API = Baseurl + "announcementController/selectAnnouncementList";
      const paramsData = {
        page: this.page,
        size: this.size,
      };
      this.loadingTable = true
      ajaxPost(API, paramsData).then(res => {
        this.loadingTable = false
        const { code, data } = res.data;
        if (code === 200) {
          this.total = data.total;
          this.listTable = data.list;
        }
      });
    },
    editNotice(row) {
      this.dialogType = "edit";
      this.dialogAddEditNoticeVisible = true;
      this.formAddNotice = JSON.parse(JSON.stringify(row));
      this.fileList = row.accessoryList.map(item => ({
        name: item.accessoryName,
        url: item.accessoryUrl,
        id: item.accessoryId,
      }));
      this.$nextTick(() => {
        this.$refs.tinymce.setContent(this.formAddNotice.content);
      });
    },
    removeFile(id) {
      const API = Baseurl + "accessoryController/deleteAccessory";
      const paramsData = { accessoryId: id };
      ajaxPost(API, paramsData).then(res => {
        const { data: { code } } = res;
        if (code === 200) {
          this.$message.success("操作成功");
          this.getListTable();
        } else {
          this.$message.error("操作失败");
        }
      });
    },
    releaseNotice(row) {
      this.$confirm('是否确认发布？', '公告发布').then(() => {
        const API = Baseurl + "announcementController/releaseAnnouncementInfo";
        const paramsData = {
          rid: this.UserInfo.rid,
          id: row.id,
          releaseTime: "",
        };
        ajaxPost(API, paramsData).then(res => {
          const { data: { code } } = res;
          if (code === 200) {
            this.$message.success("操作成功");
            this.getListTable();
          } else {
            this.$message.error("操作失败");
          }
        });
      })
    },
    recallNotice(item) {
      this.$confirm('是否确认撤回？', '公告撤回').then(() => {
        const API = Baseurl + "announcementController/revokeAnnouncement";
        const paramsData = {
          id: item.id,
        };
        ajaxPost(API, paramsData)
            .then(res => {
              const { data: { code } } = res;
              if (code === 200) {
                this.$message.success("操作成功");
                this.getListTable();
              } else {
                this.$message.error("操作失败");
              }
            })
      })
    },
    seeNotice(item) {
      this.seeForm = JSON.parse(JSON.stringify(item))
      this.dialogSeeNoticeVisible = true
    },
    delNotice(item){
      this.$confirm('是否确认删除？', '公告删除').then(() => {
        const API = Baseurl + "announcementController/removeAnnouncement";
        const paramsData = {
          id: item.id,
        };
        ajaxPost(API, paramsData)
            .then(res => {
              const { data: { code } } = res;
              if (code === 200) {
                this.$message.success("删除成功");
                this.getListTable();
              } else {
                this.$message.error("删除失败");
              }
            })
      })
    }
  },
};
</script>

<style lang="scss" scoped>
.addInformation {
  width: 98%;
  overflow: hidden;
  padding-bottom: 72px;

  .pagination-container {
    width: 1660px;
    padding: 20px;
    position: fixed;
    right: 0;
    bottom: 0;
    background: #fff;
    z-index: 999;

    .el-pagination {
      display: flex;
      justify-content: center;
    }
  }

  .add-notice-row {
    margin-bottom: 10px;

    .title {
      flex-shrink: 0;
      margin-right: 10px;
    }
  }

  .upload-container {
    width: 40%;
  }

  ::v-deep {
    .notice-content {
      img {
        max-width: 100%;
      }
    }
  }
}
</style>
